import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={colorValue}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7077 2.5893C11.9985 2.53153 12.2999 2.56123 12.5739 2.67465C12.8478 2.78808 13.0819 2.98013 13.2468 3.22656C13.4116 3.47299 13.4997 3.76275 13.5 4.05923V19.9399C13.4997 20.2364 13.4116 20.5268 13.2468 20.7732C13.0819 21.0196 12.8478 21.2117 12.5739 21.3251C12.2999 21.4385 11.9985 21.4682 11.7077 21.4105C11.4169 21.3527 11.1498 21.2101 10.94 21.0005L6.43934 16.4999H4.51C3.36794 16.4999 2.19148 15.8349 1.84909 14.5956L1.84881 14.5946C1.6165 13.7492 1.49917 12.8763 1.5 11.9995C1.50004 11.1018 1.62123 10.232 1.84889 9.40487C2.19131 8.16396 3.36841 7.49989 4.51 7.49989H6.43934L10.9397 2.99956C11.1494 2.79005 11.4169 2.64707 11.7077 2.5893ZM7.28033 8.78022L12 4.06055V19.9392L7.28033 15.2196C7.13968 15.0789 6.94892 14.9999 6.75 14.9999H4.51C3.89226 14.9999 3.42083 14.6511 3.29504 14.1966C3.09851 13.4812 2.99927 12.7418 3 11.9999C3 11.2379 3.10278 10.5019 3.295 9.80332C3.42061 9.34826 3.89164 8.99989 4.51 8.99989H6.75C6.94892 8.99989 7.13968 8.92087 7.28033 8.78022Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5837 5.10556C18.8766 4.81267 19.3514 4.81266 19.6443 5.10555C20.5497 6.01093 21.2679 7.08576 21.7579 8.2687C22.2479 9.45163 22.5001 10.7195 22.5001 11.9999C22.5001 13.2803 22.2479 14.5481 21.7579 15.7311C21.2679 16.914 20.5497 17.9888 19.6443 18.8942C19.3514 19.1871 18.8766 19.1871 18.5837 18.8942C18.2908 18.6013 18.2908 18.1264 18.5837 17.8336C19.3498 17.0675 19.9575 16.158 20.3721 15.157C20.7867 14.1561 21.0001 13.0833 21.0001 11.9999C21.0001 10.9165 20.7867 9.84367 20.3721 8.84273C19.9575 7.84178 19.3498 6.93231 18.5837 6.16622C18.2908 5.87333 18.2908 5.39846 18.5837 5.10556Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9934 7.7576C16.7005 7.46468 16.2256 7.46464 15.9327 7.75751C15.6398 8.05038 15.6398 8.52526 15.9326 8.81817C16.7764 9.66207 17.2504 10.8065 17.2504 11.9999C17.2504 13.1932 16.7764 14.3377 15.9326 15.1816C15.6398 15.4745 15.6398 15.9494 15.9327 16.2423C16.2256 16.5351 16.7005 16.5351 16.9934 16.2422C18.1184 15.117 18.7504 13.591 18.7504 11.9999C18.7504 10.4088 18.1184 8.88279 16.9934 7.7576Z"
        fill={colorValue}
      />
    </svg>
  );
};
